import './FeedItem.scss';
import FeedItemProps from './FeedItemProps';
import source_sheet_symbol from '../../../../assets/images/source-sheet-symbol-bold.svg';
import article_symbol from '../../../../assets/images/article-symbol-bold.svg';
import video_symbol from '../../../../assets/images/video-small-symbol.svg';
import file_symbol from '../../../../assets/images/file-small-symbol.svg'
import { BsBoxArrowUpRight as BoxArrowUpIcon } from "react-icons/bs";
import { BsDownload as DownloadIcon } from "react-icons/bs";
import { BsFillPinAngleFill as PinAngleFillIcon } from "react-icons/bs";
import { Streamer } from '../../../core/Streamer/Streamer';
import avatar from '../../../../assets/images/avatar.png';
import { useState } from 'react';
import { useEffect } from 'react';
import { useCallback } from 'react';
import { hasVideo, navigateToContent, openFile, openLink, renderSubTitle, renderUserName } from '../../Globals/globals';
import { useDispatch } from 'react-redux';
import { setCurrentPost } from '../../../../store/actions/contentActions';
import { useNavigate }  from 'react-router-dom';
const FeedItem = (props: FeedItemProps) => {
    const navigate = useNavigate();
    const { item } = props;
    const [state, setState] = useState({ file: '', thumbnail: "", loading: true });
    const [mounted, setMounted] = useState(true)
    const dispatch = useDispatch();

    const filterFeedByUser = (e: any) => {
        navigate('/search/' + e);
    }

    const goToCommunityPage = (id: string) => {
        navigate('/community/' + id)
    }    

    const getFiles = useCallback(async () => {
        if (item.content.media)
            if (item.content.media[0].file && item.content.type !== 'external_link' && item.content.type !== 'recording_session') {
                let _file, _thumbnail;
                if (item.content.media[0].azureLink) {
                    _file = item.content.media[0].azureLink;
                }
                _thumbnail = item.content.thumbnail;
                let file = '', thumbnail = '';
                if (_thumbnail) {
                    thumbnail = _thumbnail;
                }
                if (_file) {
                    file = _file;
                }
                if (mounted)
                    setState({
                        file,
                        thumbnail,
                        loading: false
                    })
            }
    }, [item, mounted]);

    useEffect(() => {
        getFiles()
        return () => {
            setMounted(false)
        }
    }, [getFiles, setMounted])

    const renderTitle = () => {
        let title;
        if (item.content.type === 'sefaria_link') {
            title = <div className="feedTitle">Source Sheet {renderUserName(item)}</div>
        }
        else if (item.content.type === 'file') {
            title = <div className="feedTitle"> {item.content.title}</div>
        }
        else if (item.content.type === 'quick_post') {
            title = <div className="feedTitle"> New message {renderUserName(item)}</div>
        }
        else if (item.content.type === 'hartman_link') {
            title = <div className="feedTitle"> {item.content.title}</div>
        }
        else if (item.content.type === 'recording_session') {
            title = <div> Shared Session Recording Link {renderUserName(item)}</div>
        }
        if (hasVideo(item.content)) {
            title = <div className="feedTitle"> Shared {renderUserName(item)}</div>
        } else if (item.content.type === 'external_link') {
            title = <div className="feedTitle"> Shared {renderUserName(item)}</div>
        } else if (item.content.type === 'recording_session') {
            title = <div> Shared {renderUserName(item)}</div>
        }

        return title;

    }

    const renderDescription = () => {


                // {item.sameContentItemPostEntries.map((item: any,index: number)=>{
                //     return index>0 ? <div key={index}>{item.community[0].communityTitle} - {item.post} - {item.user[0].fullName} - {item.createdAt}</div> : null
                // })}        
        
        let hebrewPost = (/[\u0590-\u05FF]/).test(item.post);

        let description;

        if (item.sameContentItemPostEntries && item.sameContentItemPostEntries.length === 1) {

            if (item.post) {
                description = <div className={hebrewPost ? "note description px-3 pb-3 hebrewPost" : "note description px-3 pb-3"}>{item.post}</div>
            }

        } else {

            
                description = <div className={hebrewPost ? "note description px-3 pb-3 hebrewPost" : "note description px-3 pb-3"}>

                {item.sameContentItemPostEntries && item.sameContentItemPostEntries[0].post ? <div className='lastPostItem'>{item.sameContentItemPostEntries[0].post}</div> : null}

                {item.sameContentItemPostEntries && item.sameContentItemPostEntries[0].post ? <div className='addtionalCommunitiesTitle'>Additional publications: </div> : null}
                    
                    <div className='communitiesList'>

                        {item.sameContentItemPostEntries && item.sameContentItemPostEntries.map((item: any,index: number, sameContentItemPostEntries)=>{
                            return index>0 && index < sameContentItemPostEntries.length -1 ? <div className='communityItem' key={index} onClick={() => {goToCommunityPage(item.community[0]._id) }} >{item.community[0].communityTitle} | </div> : 
                            index>0 && index < sameContentItemPostEntries.length ? <div className='communityItem' key={index} onClick={() => {goToCommunityPage(item.community[0]._id) }} >{item.community[0].communityTitle} </div> : null
                        })}
                    
                    </div>
                            
                </div>         

        }


        // if (item.post) {
        //     description = <div className={hebrewPost ? "note description px-3 pb-3 hebrewPost" : "note description px-3 pb-3"}>{item.post}</div>
        // }
        return description;
    }

    const getSymbol = () => {
        let symbol;
        if (item.content.type === 'file') {
            symbol = file_symbol;
        }
        else if (item.content.type === 'sefaria_link') {
            symbol = source_sheet_symbol;
        } else if (item.content.type === "hartman_link") {
            symbol = article_symbol;
        }
        if (hasVideo(item)) {
            symbol = video_symbol;
        } else if (item.content.type === 'external_link') {
            symbol = '';
        } else if (item.content.type === 'recording_session') {
            symbol = video_symbol;
        }
        return symbol;
    }



    const renderGoToFileOrLink = (photo?: any) => {
        let external;

        if (item.content.type === "file") {
            external = <div className="download-wrap">
                {photo ? photo : null}
                <div className="download-bar px-3 py-1">
                    <DownloadIcon className="download-icon" onClick={(e) => {openLink(item.content.media[0]?.azureLink, e) }} />
                </div>
            </div>
        } else if (item.content.type === 'external_link') {
            external = <div className="photo-wrap">
                {photo ? photo : null}
                <div className="shared-bar px-3 py-2" onClick={(e) => { openLink(item.content.media[0]?.link, e) }}>
                    <div>
                        <div className="shared-external-url">
                            {item.content.media[0]?.link}
                        </div>                    
                        <div className="shared-site">{item.content.title}</div>
                    </div>
                    <BoxArrowUpIcon className="shared-icon" />
                </div>
            </div>
        } else if (item.content.type === 'hartman_link') {
            photo ?
            external = <div className="photo-wrap">
                {photo ? photo : null}
                 {/* <div className="shared-bar px-3 py-2" onClick={() => navigateToContent(item, history, () => {
                    dispatch(setCurrentPost(item))
                })}>
                    <div>
                        <div className="shared-site">{item.content.title}</div>
                        <div className="shared-title ">
                            Go to hartman content
                        </div>
                    </div>
                </div> */}
            </div> : external = null
        }
        return external;
    }

    const renderPhotoAndLink = () => {
        let photo;
        if ((state.thumbnail || item.content.thumbnail) && item.content.type !== "sefaria_link") {
            let src: any = '';
            src = (item.content.type === 'external_link' || item.content.type === 'hartman_link' || item.content.type === 'file') && item.content.thumbnail ? item.content.thumbnail : state.thumbnail;
            photo = <img className="photo" src={src} alt="p" />
            photo = renderGoToFileOrLink(photo) ? renderGoToFileOrLink(photo) : photo;
        } else {
            photo = renderGoToFileOrLink()
        }
        return photo
    }

    const renderVideo = () => {
        let video;
        if (hasVideo(item.content)) {
            if (state.file)
                video = <Streamer file={state.file} ></Streamer>
            else if (item.content.media[0]?.link)
                video = <Streamer link={item.content.media[0].link}></Streamer>
        }
        return video
    }

    const renderSymbol = () => {
        let symbol;
        symbol = getSymbol() ? <img className="symbol" src={getSymbol()} alt="symbol" /> : null
        return symbol;
    }

 

    return (
        <div className="feed-item">
            <div className="wrapper">
                <div className="details-row p-2 py-4">
                    <div className="d-flex justify-content-center align-item-md-center align-items-top mx-2">
                        {
                            item?.user && item?.user[0] && item?.user[0]?.image ?
                                <img className="user-photo filterBycreator" src={item?.user && item?.user[0] && item?.user[0]?.image ? item?.user[0]?.image : avatar} alt="publish user"
                                     onClick={()=> filterFeedByUser(item?.user[0].fullName)} /> :
                                 <div className="userInitialsInFeed">{item?.user[0]? item.user[0].firstName.charAt(0) + item.user[0].lastName.charAt(0) : null}</div>
                        }

                    </div>
                    <div className="summary">                    
                        <div className="title" onClick={() => navigateToContent(item, navigate, () => {
                            dispatch(setCurrentPost(item))
                        })}>
                            {renderTitle()}
                        </div>
                        <div className="subTitle">
                            {renderSubTitle(item, filterFeedByUser, goToCommunityPage)}
                        </div>
                    </div>
                    <div className="pinnedPost">
                        {item.postSettings[0].pinToTop ? <PinAngleFillIcon /> : null}
                    </div> 
                    {renderSymbol()}
                </div>
                 {renderDescription()} 

            </div>
            {renderVideo() ? renderVideo() : renderPhotoAndLink()}
        </div>
    )
}

export default FeedItem;
